import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import type { UseModalState } from "@src/appV2/redesign/system/ui-components";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
} from "@src/appV2/redesign/system/ui-components";
import { SKILLS_ASSESSMENT_BASE_PATH } from "@src/appV2/SkillsAssessment/paths";
import { useHistory } from "react-router-dom";

interface OrientationReadyToStartAlertBottomSheetProps {
  modalState: UseModalState;
  scheduledForTimeString: string;
  isWorkerOnTime: boolean | undefined;
}

export function OrientationReadyToStartAlertBottomSheet(
  props: OrientationReadyToStartAlertBottomSheetProps
) {
  const { modalState, scheduledForTimeString, isWorkerOnTime } = props;
  const history = useHistory();

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" sx={{ marginTop: 5, marginBottom: 5 }}>
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => {
              logEvent(
                APP_V2_USER_EVENTS.CLIPBOARD_ORIENTATION_START_TIME_PASSED_ALERT_CTA_CLICKED
              );
              modalState.closeModal();
              history.push(SKILLS_ASSESSMENT_BASE_PATH);
            }}
          >
            Take me there
          </Button>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            sx={{
              color: (theme) => theme.palette.primary.dark,
            }}
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.CLIPBOARD_ORIENTATION_START_TIME_PASSED_ALERT_DISMISSED);
              modalState.closeModal();
            }}
          >
            Not now
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="calendar-alert"
        title="It's time for your Demo Shift!"
        description={`${
          isWorkerOnTime
            ? `Your Demo Shift scheduled for ${scheduledForTimeString} is starting now. Join promptly to
          avoid being marked late.`
            : `The time you scheduled has passed and you can take it now. Join promptly to avoid showing up any later.`
        }`}
      />
    </BottomSheet>
  );
}
